import {useLocalStorageState} from '@coolcolduk/ui-common-hook';
import {z} from 'zod';

/**
 * Extension of useLocalStorageState that validates the stored value with a zod schema.
 * If the value is invalid, returns the default value (does not overwrite localStorage).
 *
 * @deprecated Prefer useLocalStorageState with explicit validation at the call site, or move this to a shared package.
 */
export default function useLocalStorageStateWithValidation<T>(
  key: string,
  defaultValue: T,
  schema: z.ZodType<T>,
): [T, (value: T) => void] {
  const [stored, setStored] = useLocalStorageState<T>(key, defaultValue);

  const parsed = schema.safeParse(stored);
  const value: T = parsed.success ? parsed.data : defaultValue;

  const setValue = (next: T) => {
    const nextParsed = schema.safeParse(next);
    if (nextParsed.success) {
      setStored(nextParsed.data);
    }
  };

  return [value, setValue];
}
